(() => {
 const init = (scope = document) => scope.querySelectorAll('[data-bbcr-home]').forEach(root => {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const montage = root.querySelector('[data-bbcr-montage]');
  const button = root.querySelector('[data-bbcr-montage-toggle]');
  const slides = montage ? [...montage.querySelectorAll('[data-montage-slide]')] : [];
  if (!montage || !button || !slides.length) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let current = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
  let playing = !reduced.matches;
  let timer = null;
  const update = () => {
   button.textContent = playing ? root.dataset.pause : root.dataset.play;
   button.setAttribute('aria-label', button.textContent);
   button.setAttribute('aria-pressed', String(playing));
  };
  const showNext = () => {
   slides[current].classList.remove('is-active');
   slides[current].setAttribute('aria-hidden', 'true');
   current = (current + 1) % slides.length;
   slides[current].classList.add('is-active');
   slides[current].setAttribute('aria-hidden', 'false');
  };
  const stop = () => { if (timer) clearInterval(timer); timer = null; };
  const start = () => { stop(); timer = setInterval(showNext, 5000); };
  button.addEventListener('click', () => {
   playing = !playing;
   if (playing) start(); else stop();
   update();
  });
  reduced.addEventListener('change', event => {
   if (event.matches) { playing = false; stop(); }
   else { playing = true; start(); }
   update();
  });
  document.addEventListener('visibilitychange', () => {
   if (document.hidden) stop();
   else if (playing) start();
  });
  if (playing) start();
  update();
 });
 init();
 document.addEventListener('shopify:section:load', event => init(event.target));
})();